import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import type {
  OnboardingTooltipMessage,
  OnboardingTooltipProps,
} from 'tripPlanner/Tripkit/Onboarding/OnboardingTooltip'
import OnboardingTooltip from 'tripPlanner/Tripkit/Onboarding/OnboardingTooltip'
import type { BasicTrip } from 'tripPlanner/types/common'

type Props = Omit<
  OnboardingTooltipProps,
  | 'messages'
  | 'skipLabel'
  | 'backgroundOpacity'
  | 'isScrollLocked'
  | 'autoDismissTimeout'
> & {
  trip: BasicTrip
}

export default function FirstTripItemOnboardingTooltip(props: Props) {
  const { trip } = props
  const intl = useIntl()
  const messages = useMemo<Array<OnboardingTooltipMessage>>(() => [
    {
      title: intl.formatMessage(
        {
          id: 'lGEP3GJy4Ba1_ciuCDpO',
          defaultMessage: 'Offer saved to ”{tripName}”',
          description: 'Onboarding tooltip title shown after saving the first item to a trip in the trip planner',
        },
        { tripName: trip.name },
      ),
      content: intl.formatMessage({
        id: '53qiM99FlJ6O1sa9-5tv',
        defaultMessage: 'We’ve added your first saved item to your trip',
        description: 'Onboarding tooltip body text shown after saving the first item to a trip in the trip planner',
      }),
    },
  ], [intl, trip.name])
  return (
    <OnboardingTooltip
      {...props}
      messages={messages}
      skipLabel=""
      backgroundOpacity={0}
      isScrollLocked={false}
      autoDismissTimeout={8000}
      showTopArrow
      className="flatShadow"
    />
  )
}
